import i18n from "../../../../../constants/i18n";
import { FLAGGED_DESCRIPTION_HEADERS } from "../../../../../constants/table-custom-headers/Supervisor";
import getFlaggedDesctiprionStore from "../../../../../stores/supervisor-store/flagged-description-store";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import Et3Table from "../../../../../core/et3-table";

const FlaggedDescriptionData = withLiteObserverAndTheme(() => {
  const flaggedDescriptions =
    getFlaggedDesctiprionStore().flaggedDescriptions.get();

  return (
    <Et3Table
      columns={FLAGGED_DESCRIPTION_HEADERS}
      rows={flaggedDescriptions}
      title={i18n.get("FLAGGED_DESCRIPTION")}
      shouldBeFlagged={false}
      titleKey={"FLAGGED_DESCRIPTIONS_TABLE"}
    />
  );
});

export default FlaggedDescriptionData;
